import type { RouteRecordRaw } from 'vue-router';

/**
 * Planning / MRP web screens (M8, DECISIONS.md "ADR-086 — Planning / MRP (M8, WP8.3)"). Follows the
 * parallel-work convention established by `procurement.ts`/`sales.ts` — `router.ts` only spreads this
 * array into the app-shell `children`.
 */
export const planningRoutes: RouteRecordRaw[] = [
  {
    path: 'planning/parameters',
    name: 'planning-parameters',
    component: () => import('../pages/planning/PlanningParametersPage.vue'),
    meta: { requiresModule: 'planning' },
  },
  {
    path: 'planning/demand',
    name: 'planning-demand',
    component: () => import('../pages/planning/ManualDemandPage.vue'),
    meta: { requiresModule: 'planning' },
  },
  {
    path: 'planning/runs',
    name: 'planning-runs',
    component: () => import('../pages/planning/MrpRunsPage.vue'),
    meta: { requiresModule: 'planning' },
  },
  {
    path: 'planning/runs/:id',
    name: 'planning-run-detail',
    component: () => import('../pages/planning/MrpRunDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'planning' },
  },
];
